import { useUpdateLabRequisitionViewedAtMutation } from '@pm/graphql';
import { useToast } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { detectUserErrors } from '../../modules/errors/errors';

type ViewableRequisition = {
  id: string;
  readByPatientAt?: string | null;
};

export const useMarkRequisitionViewed = (labReq: ViewableRequisition) => {
  const { t } = useTranslation('global');
  const { negative } = useToast();
  const [updateViewedAt, { loading }] =
    useUpdateLabRequisitionViewedAtMutation();

  const markAsViewed = async () => {
    if (labReq.readByPatientAt) {
      return;
    }

    const viewedAt = new Date().toISOString();
    try {
      const { data } = await updateViewedAt({
        variables: { input: { id: labReq.id, viewedAt } },
        update: (cache) => {
          cache.modify({
            id: cache.identify({ __typename: 'LabRequisition', id: labReq.id }),
            fields: { readByPatientAt: () => viewedAt },
          });
        },
      });
      detectUserErrors(data, (res) => res.updateLabRequisitionViewedAt?.errors);
    } catch {
      negative({ content: t('Errors.SomethingWentWrong') });
    }
  };

  return { markAsViewed, loading };
};
